import { render, staticRenderFns } from "./LaporanBankDarahMenuPage.vue?vue&type=template&id=517d3375&scoped=true&"
import script from "./LaporanBankDarahMenuPage.vue?vue&type=script&lang=ts&"
export * from "./LaporanBankDarahMenuPage.vue?vue&type=script&lang=ts&"
import style0 from "./LaporanBankDarahMenuPage.vue?vue&type=style&index=0&id=517d3375&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517d3375",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VAvatar,VCard,VCardText,VCol,VContainer,VIcon,VRow})
